/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import template from './related-data-domain.component.html';

@Component({
  standalone: false,
  selector: 'adn-related-data-domain',
  template
})
export class RelatedDataDomainComponent {
  @Input() allStats: any;
  @Input() countType: any;
  @Input() relatedChartData: any;
  @Input() chartType: string;
  @Input() domainsEmpty = false;
  @Input() isPending = false;
}
